module.exports = __webpack_public_path__ + "img/medical.60afb181.svg";